export enum UnitValueEnum {
    DROPDOWN = 'DROPDOWN',
    BOOLEAN = 'BOOLEAN',
}